import mixins from 'vue-typed-mixins';

import WindowAdjustMixin from '@/user/mixins/WindowAdjustMixin';

import UserPathData from '@/classes/data/UserPathData';


/** 文字色 */
export const TEXT_COLOR = 'rgba(0, 0, 0, 1)';

/** 筆跡色 */
export const PEN_COLOR = 'rgba(85, 85, 85, 1)';

/** 筆跡キャップ */
const PEN_CAP = 'round';


export default mixins(WindowAdjustMixin).extend({

  name: 'StudyWorkMixin',

  data(): {
    penColor: string;  // importするcomponentで上書き可能
    // 以下private
    isHandWriting: boolean;
    pathData: UserPathData;
  } {
    return {
      penColor: PEN_COLOR,
      isHandWriting: false,
      pathData: new UserPathData(),
    };
  },

  computed: {
    canvas(): HTMLCanvasElement {
      const canvas = this.$refs.canvas;
      if (canvas === undefined) throw new Error('canvas未初期化');
      return canvas as HTMLCanvasElement;
    },
    canvasContext(): CanvasRenderingContext2D {
      const context = this.canvas.getContext('2d');
      if (context === null) throw new Error('context未初期化');
      return context;
    },
  },

  methods: {

    // importするcomponentのmountedで呼び出す想定
    initializeCanvas(): void {
      this.setCanvasSize();
      this.setCanvasLineStyle();
      this.canvasContext.lineCap = PEN_CAP;
      this.canvasContext.lineJoin = PEN_CAP;
    },

    // importするcomponentのmounted, onChangeWindowSizeHandlerで呼び出す想定
    setCanvasSize(): void {
      this.canvas.width = this.canvas.clientWidth;
      this.canvas.height = this.canvas.clientHeight;
    },

    setCanvasLineStyle(): void {
      this.canvasContext.lineWidth = 0;
      this.canvasContext.strokeStyle = this.penColor;
    },

    onTouchStart(e: TouchEvent | MouseEvent): void {
      // スクロール処理の場合は終了
      if (this.$_preventScroll(e)) return;

      this.setCanvasLineStyle();

      const rect = this.canvas.getBoundingClientRect();
      const xy = this.$_eventXy(e);
      const x = xy.x - rect.left;
      const y = xy.y - rect.top;
      this.isHandWriting = true;
      this.pathData.start(x, y);
    },

    onTouchMove(e: TouchEvent | MouseEvent): void {

      // 手書き中で1画の最大点に達していない場合のみ有効
      if (!this.isHandWriting || this.pathData.pointCount >= this.pathData.MAX_POINT_COUNT) return;

      const rect = this.canvas.getBoundingClientRect();
      const xy = this.$_eventXy(e);
      const x = xy.x - rect.left;
      const y = xy.y - rect.top;

      // キャンバスから外れた場合はタッチ終了とみなす
      // -5 は目算値
      if (this.canvas.width - 5 <= x || x - 5 <= 0 || this.canvas.height - 5 <= y || y - 5 <= 0) {
        this.onTouchEnd();
        return;
      }

      const dx = Math.abs(x - this.pathData.pointLastX);
      const dy = Math.abs(y - this.pathData.pointLastY);

      // 最低移動距離（ペンサイズ）に達していない場合は何もしない
      const penSize = this.canvasContext.lineWidth;
      if (dx < penSize && dy < penSize) return;

      // 筆跡の追加
      this.pathData.add(x, y);

      // 枠外からの入力などでポイント数が2点に満たない場合はここで終了
      if (this.pathData.pointCount < 2) return;

      // 筆跡描画
      const xFrom = this.pathData.pointX[this.pathData.pointCount - 1];
      const yFrom = this.pathData.pointY[this.pathData.pointCount - 1];
      const xTo   = this.pathData.pointX[this.pathData.pointCount - 2];
      const yTo   = this.pathData.pointY[this.pathData.pointCount - 2];
      this.canvasContext.beginPath();
      this.canvasContext.moveTo(xFrom, yFrom);
      this.canvasContext.lineTo(xTo, yTo);
      this.canvasContext.stroke();
      this.canvasContext.closePath();
    },

    onTouchEnd(): void {
      // 手書き中でない場合はreturn
      if (!this.isHandWriting) return;

      // 次の手書きへの準備
      this.pathData.clear();
      this.isHandWriting = false;
    },

    $_eventXy(e: TouchEvent | MouseEvent): {
      x: number;
      y: number;
    } {
      const xy = {
        x: 0,
        y: 0,
      };
      if (e.type.indexOf('touch') > -1) {
        xy.x = (e as TouchEvent).changedTouches[0].pageX;
        xy.y = (e as TouchEvent).changedTouches[0].pageY;
      } else {
        xy.x = (e as MouseEvent).pageX;
        xy.y = (e as MouseEvent).pageY;
      }
      return xy;
    },

    $_preventScroll(e: TouchEvent | MouseEvent): boolean {
      if ('touches' in e && e.touches.length > 0) {
        // Canvas要素だけはタップイベントに反応したいので、抑止しない。
        const touch1st = e.touches[0].target as HTMLElement;
        const eventTarget = e.target as HTMLElement;
        if (touch1st.tagName.toLowerCase() === eventTarget.id) return true;

        // preventDefaultでブラウザ標準動作を抑止する。
        e.preventDefault();
      }
      return false;
    },
  },

});
